import { InfoTooltip } from "@/features/InfoTooltip";
import { cn } from "@/shared/lib/utils";

interface UnnasignedTgTooltipProps {
  offset?: number;
}

export const UnnasignedTgTooltip = ({
  offset = -2,
}: UnnasignedTgTooltipProps) => {
  return (
    <InfoTooltip
      style={{ right: offset }}
      className={cn("absolute top-1/2 -translate-y-1/2")}
      warning={true}
    >
      <p>Тг аккаунт не привязан</p>
    </InfoTooltip>
  );
};
